import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#006eff",
  borderRadius: 2,
  boxShadow: 16,
  p: 2,
};

const CustomModal = ({ open, onClose, title, onPushToNewSite }) => {
  const [dropdownValue, setDropdownValue] = useState("");
  const [numberValue, setNumberValue] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);
      await onPushToNewSite({
        platform: dropdownValue,
        rating: numberValue,
      });
      setDropdownValue("");
      setNumberValue("");
      onClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6" color="white">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <IoMdClose color="white" />
          </IconButton>
        </Box>

        {/* Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            labelId="dropdown-label"
            value={dropdownValue}
            displayEmpty
            onChange={(e) => setDropdownValue(e.target.value)}
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: 1,
              color: "#000",
              fontWeight: 500,
              "& .MuiSelect-icon": {
                color: "#000",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: "#fff",
                },
              },
            }}
            inputProps={{
              sx: {
                padding: "8px",
              },
            }}
          >
            <MenuItem value="" disabled>
              Select platform
            </MenuItem>
            <MenuItem value="CodeForces">CodeForces</MenuItem>
            <MenuItem value="Geeks for Geeks">Geeks for geeks</MenuItem>
            <MenuItem value="Codechef">Codechef</MenuItem>
            <MenuItem value="Leetcode">Leetcode</MenuItem>
            <MenuItem value="Atcoder">Atcoder</MenuItem>
            <MenuItem value="Cses">Cses</MenuItem>
          </Select>
        </FormControl>

        {/* Number Input */}
        <TextField
          variant="outlined"
          value={numberValue}
          placeholder="Enter problem rating"
          onChange={(e) => setNumberValue(e.target.value)}
          fullWidth
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            "& input": {
              fontWeight: 500,
              padding: "8px",
            },
          }}
        />
        <div className="w-full flex items-center justify-center mt-4">
          <button
            className="p-2 px-8 rounded-md font-semibold border border-[#38B7FF] text-white text-sm"
            onClick={onSubmit}
          >
            {loading ? "Loading..." : "Push"}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default CustomModal;
